import { Outlet, useLocation } from 'react-router-dom'
import { useSyncNavigationHistory } from './navigationHistory'

/** Синхронизирует стек навигации (PUSH/REPLACE/POP) для resolveReturnPath и аналогичных сценариев. */
export const NavigationStackGuard = () => {
    const location = useLocation()
    useSyncNavigationHistory(location)

    return <Outlet />
}
